<template>
  <div id="whatscoveredd" class="whatscoveredwindow">
    <h4>Accidental Damage Personal Property Coverage</h4>
    <span class="poweredby" style="margin-top: -19px; margin-bottom: 29px">
      Provided by NSSI
    </span>
    <span
      class="poweredby"
      style="
        margin-top: -19px;
        margin-bottom: 29px;
        background-color: #f3f3f3;
        color: #777;
      "
      >Optional Add-On</span
    >
    <p>
      NSSI understands personal devices are essential for education. If you drop
      your phone, a cracked screen could set you back hundreds of dollars. With
      NSSI, you aren't paying retail to get your device back again. Do you rely
      on your laptop and would need a repair asap if it got damaged? We payout
      claims quickly so you have it back sooner.
    </p>
    <p>
      You know those standard phone or laptop protection plans? They are costly,
      only protect one device, and may have limited claims – leaving you paying
      hundreds out-of-pocket! With NSSI, it’s like having an all-in-one
      protection plan on your personal devices. And that’s not all… we also
      provide unlimited claims and coverage for all makes and models – new,
      used, refurbished, rented, or owned!
    </p>
    <p></p>
    <br />
    <hr />
    <br />
    <h5>Incidents Covered</h5>
    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="whatscovered-bullets"
    >
      <tbody>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img
              :src="require('@/assets/images/icon3.svg')"
              alt="Accidental Damage"
            />
          </td>
          <td valign="top" style="padding-bottom: 0px">
            <strong>Accidental Damage </strong>*<br />
            From cracked screens to coffee spills, to even dropping your phone
            in the pool, NSSI will take care of your damaged device.<br />
            <small
              >* 30 day waiting period required on accidental damage claims for
              new policies.
            </small>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <hr />
    <br />
    <h5>Items covered</h5>
    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="whatscovered-bullets"
    >
      <tbody>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img
              :src="require('@/assets/images/icon13.svg')"
              alt="Items Covered"
            />
          </td>
          <td>
            Laptops, Tablets, Cell Phones, TVs, Blu-ray Players, Game Consoles,
            Cameras, Clothing, Jewelry, Sports Equipment, Musical Instruments,
            Books, Furniture, Appliances and more.
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <hr />
    <br />
    <p>
      <small style="line-height: 22px">
        <a href="https://www.nssi.com/insurance/policy-booklet" target="_blank"
          >Download NSSI Policy Booket</a
        >
        to view complete coverage details including limitations and exclusions
        (terms and conditions). Coverages vary by state.
      </small>
    </p>
  </div>
</template>
